module.exports = __webpack_public_path__ + "img/relvado_es.b224c537.jpg";